export default __webpack_public_path__ + "static/media/5.ce94d832.webp";